import React from "react";
import { Link } from "gatsby";
import Layout from "../components/layout";
import FeaturedMagazine from "../components/magazine/featured-magazine";
import PageSectionContainer from "../components/common/page-section-container";
import PageSectionHeading from "../components/common/page-section-heading";
import SubscriptionRequestCircle from "../components/common/subscription-request-circle"; // @ts-ignore
import SEO from "../components/seo";
import MagazineItem from "../components/magazine/item";
var MagazinesPage = function MagazinesPage(_ref) {
    var data = _ref.data, location = _ref.location;
    var magazines = data.allDatoCmsMagazine.edges;
    var featuredMagazine = magazines[0].node;
    var renderMagazines = function renderMagazines(magazines, indexIncrease) {
        return magazines.map(function (edge, index) {
            var magazine = edge.node;
            return /*#__PURE__*/ React.createElement(MagazineItem, {
                to: "/themenhefte/" + magazine.slug + "/",
                title: magazine.title,
                label: magazine.label,
                description: magazine.shortDescriptionOverview,
                image: magazine.image.fluid,
                index: index + (indexIncrease ? indexIncrease : 0),
                key: index
            });
        });
    };
    return /*#__PURE__*/ React.createElement(Layout, {
        location: location
    }, /*#__PURE__*/ React.createElement(SEO, {
        title: "Themenhefte"
    }), /*#__PURE__*/ React.createElement(FeaturedMagazine, {
        key: featuredMagazine.id,
        to: "/themenhefte/" + featuredMagazine.slug + "/",
        title: featuredMagazine.title,
        description: featuredMagazine.description,
        shortDescription: featuredMagazine.shortDescription,
        image: featuredMagazine.image.fluid,
        authors: featuredMagazine.authors
    }), /*#__PURE__*/ React.createElement(PageSectionContainer, null, /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-wrap"
    }, /*#__PURE__*/ React.createElement(PageSectionHeading, {
        title: "Mit einem Abo+ erhalten Sie ein Themenheft j\xE4hrlich",
        className: "flex-1 font-medium text-3xl h0"
    }), /*#__PURE__*/ React.createElement(Link, {
        to: "/abonnieren/plus/",
        className: "btn-makroPurple py-2 font-medium text-lg"
    }, "JETZT ABONNIEREN")), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-row flex-wrap mt-8"
    }, renderMagazines(magazines.slice(1, 4), 0))), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-row flex-wrap"
    }, renderMagazines(magazines.slice(4, 6), 4), /*#__PURE__*/ React.createElement(SubscriptionRequestCircle, {
        backgroundColor: "#fec859",
        textColor: "black",
        isMagazineOverview: true
    }), renderMagazines(magazines.slice(6), 6)));
};
var query = "1199024328";
export default MagazinesPage;
